import { Component, type ReactNode } from 'react';
import { Button, Image, Text } from '@belong/ui';
import { ERROR_BOUNDARY_STRINGS } from './error-bounday.strings';

type ErrorBoundaryProps = {
  fallback?: (props: { onRetry: () => void }) => ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can use your own error logging service here
    console.log({ error, errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback({
          onRetry: this.handleRetry,
        });
      }

      // You can render any custom fallback UI
      return (
        <div className="container">
          <div className="pt-3xl flex flex-col items-center justify-center text-center">
            <Text variant="h1" fontWeight="semibold" className="mb-xs">
              {ERROR_BOUNDARY_STRINGS.title}
            </Text>
            <Text className="mb-xl">{ERROR_BOUNDARY_STRINGS.description}</Text>
            <Button onClick={this.handleRetry}>
              {ERROR_BOUNDARY_STRINGS.button}
            </Button>
            <Image
              src="/404/belong_404_city_general_01.svg"
              className="mt-2xl h-auto w-full"
              alt=""
            />
          </div>
        </div>
      );
    }

    // Return children components in case of no error
    return this.props.children;
  }
}

export default ErrorBoundary;
